import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, IconReviewStar, ShareModal, SuperHost } from '../../components';
import shareIcon from '../../assets/shareMatter.svg';
import heartFilledIcon from '../../assets/heart-filled.svg';
import heartIcon from '../../assets/heart.svg';
import css from './ListingPage.css';

const SectionActions = props => {
  const {
    shareModalOpen,
    onShareModalClose,
    handleShareClick,
    isInMyFavorites,
    handleFavoritesClick,
    rating,
    totalReviews,
    isHostedBySuperHost,
    onManageDisableScrolling,
  } = props;

  return (
    <div className={css.sectionActions}>
      {totalReviews > 2 ? (
        <div className={css.reviewsInfoContainerDesktop}>
          <IconReviewStar className={css.iconReviewStar} isFilled />
          <span className={css.rating}>{rating}</span>
          <span className={css.totalReviews}>({totalReviews})</span>
        </div>
      ) : null}
      {isHostedBySuperHost ? (
        <SuperHost rootClassName={css.superHost} />
      ) : null}
      <Button rootClassName={css.shareButton} onClick={handleShareClick}>
        <img className={css.buttonIcon} src={shareIcon} />
        <div className={css.buttonText}>
          <FormattedMessage id="ListingPage.shareButton" />
        </div>
      </Button>
      <Button
        rootClassName={isInMyFavorites ? css.removeFromMyFavoritesButton : css.addToMyFavoritesButton}
        onClick={handleFavoritesClick}
      >
        {isInMyFavorites ? (
          <Fragment>
            <img className={css.buttonIcon} src={heartFilledIcon} />
            <div className={css.buttonText}>
              <FormattedMessage id="ListingPage.removeFromMyFavoritesButton" />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <img className={css.buttonIcon} src={heartIcon} />
            <div className={css.buttonText}>
              <FormattedMessage id="ListingPage.addToMyFavoriteButton" />
            </div>
          </Fragment>
        )}
      </Button>
      <ShareModal
        shareModalOpen={shareModalOpen}
        onShareModalClose={onShareModalClose}
        onManageDisableScrolling={onManageDisableScrolling}
      />
    </div>
  );
};

export default SectionActions;



// WEBPACK FOOTER //
// ./src/containers/ListingPage/SectionActions.js